import { randomColors } from "./tools";

/**
 * 合并折线图配置
 * @param {*} setting 
 * @param {*} option 
 */
const linechart = (setting, option) => {
    const { title, saveAsImage, legend, smooth, areaStyle, label } = setting;
    const options = {
        title: {
            text: title
        },
        toolbox: saveAsImage
    };
    legend ? (options.legend = {}) : false;
    option.series = option.series.map(item => {
        item.smooth = smooth;
        if (areaStyle) {
            item.areaStyle = {};
        }
        item.label = label;
        return item;
    });
    return { ...options, ...option };
}

/**
 * 合并条形图配置
 * @param {*} setting 
 * @param {*} option 
 */
const histogram = (setting, option) => {
    const { title, titleColor, unit, background, fontColor, barFontColor, disAxis, axisColor, splitLine, splitLineColor, average, backWatermark, legend, maxmin, randomColor, saveAsImage, scaleAlign, stacking, toLine, xAlign } = setting;
    const category = option.xAxis;
    const categoryVal = option.yAxis;
    category.axisLabel = {
        show: true,
        textStyle: {
            color: fontColor
        }
    };
    categoryVal.axisLabel = {
        show: true,
        textStyle: {
            color: fontColor
        }
    };
    categoryVal.name = unit;
    if (disAxis) {
        category.axisLine = {
            show: true,
            lineStyle: {
                color: axisColor
            }
        };
        categoryVal.axisLine = {
            show: true,
            lineStyle: {
                color: axisColor
            }
        };
    }
    if (splitLine) {
        category.splitLine = {
            show: true,
            lineStyle: {
                color: splitLineColor
            }
        };
        categoryVal.splitLine = {
            show: true,
            lineStyle: {
                color: splitLineColor
            }
        };
    }
    if (randomColor && option.series.length === 1) {
        const myColors = randomColors(option.series[0].data.length);
        option.series[0].data = option.series[0].data.map((item, i) => ({
            value: item,
            itemStyle: {
                color: myColors[i]
            }
        }))
    }
    const excelSeries = option.series.map(item => {
        item.label = {
            show: true,
            position: 'top',
            color: barFontColor
        }
        if (backWatermark) {
            item.showBackground = true;
            item.backgroundStyle = {
                color: 'rgba(180, 180, 180, 0.2)'
            };
        } if (average) {
            item.markLine = {
                data: [{ type: 'average', name: 'Avg' }]
            };
        } if (maxmin) {
            item.markPoint = {
                data: [
                    { type: 'max', name: 'Max' },
                    { type: 'min', name: 'Min' }
                ]
            };
        } if (stacking) {
            item.stack = "total";
            item.emphasis = { focus: 'series' };
            item.label.position = 'inside';
        }
        return item;
    });

    if (scaleAlign) {
        category.axisTick = { alignWithLabel: true }
    }
    const options = {
        backgroundColor: background,
        title: {
            text: title,
            textStyle: {
                color: titleColor
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        toolbox: {
            show: false,
            feature: {}
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        xAxis: category,
        yAxis: categoryVal,
        series: excelSeries,
        animation: true
    };

    if (xAlign) {
        options.xAxis = categoryVal;
        options.yAxis = category;
    } if (legend) {
        options.legend = {};
    } if (saveAsImage) {
        options.toolbox.show = true;
        options.toolbox.feature.saveAsImage = { show: true };
    } if (toLine) {
        options.toolbox.show = true;
        options.toolbox.feature.magicType = { show: true, type: ['line', 'bar'] };
    }

    return options;
}

/**
 * 合并饼图配置
 * @param {*} setting 
 * @param {*} option 
 */
const piechart = (setting, option) => {
    const serie = {
        ...option,
        radius: `${setting.radius}%`,
    }
    if(setting.shadow) {
        serie.emphasis.itemStyle = {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
        }
    }
    if(setting.border) {
        serie.itemStyle.borderColor = setting.borderStyle.color;
        serie.itemStyle.borderWidth = setting.borderStyle.width;
        serie.itemStyle.borderRadius = setting.borderStyle.radius;
    }
    if(setting.ring) {
        serie.radius = setting.ringRadius.map(item => item + '%');
        serie.label = {
            show: true,
            position: 'center'
        }
        serie.emphasis.label = {
            show: true,
            fontSize: '30',
            fontWeight: 'bold'
        }
    }
    if(setting.rose) {
        serie.radius = setting.roseRadius;
        serie.center = ['50%', '50%'];
        serie.roseType = 'area';
        serie.itemStyle.borderRadius = 8;
        serie.data = option.data.sort((a,b) => b.value - a.value);
    }
    if(setting.imgFill) {
        const img = new Image();
        img.src = setting.imgFill;
        serie.itemStyle.color = {
            image: img,
            repeat: 'no-repeat'
        }
    }
    const backColor = function(val) {
        if(/^rgba?\(.*\)$/.test(val) || /^#[0-9a-fA-F]{8}$/.test(val)) {
            return val
        }
        if(/^(https?:\/\/)/.test(val)) {
            const img = new Image();
            img.src = val;
            return {
                image: img,
                repeat: 'no-repeat'
            }
        }
    };
    const options = {
        backgroundColor: backColor(setting.background),
        title: {
            text: setting.title,
            textStyle: {
                color: setting.titleColor
            },
            left: setting.titlePosition
        },
        tooltip: { // hover悬浮状态匡
            trigger: 'item'
        },
        legend: {
            show: setting.legend,
            orient: setting.legendDirection,
            left: setting.legendPosition
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        toolbox: {
            show: true,
            feature: {
                saveAsImage: { show: setting.saveAsImage }
            }
        },
        series: [serie]
    };
    return options;
}

export {
    linechart,
    histogram,
    piechart
}